import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Nav } from "reactstrap";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { availabilityOptions, availabilityTypeOptions } from "../helpers";
import { getHeaderTooltip } from "../tooltips";

const AVAILABILITY_KEY = "availability";

const AV_TIP = {
  "+": "Beschikbaar",
  "!": "Geen keuze gemaakt",
  "+!": "Beschikbaar / geen keuze gemaakt",
};

const menuProps = {
  container: "body",
  strategy: "fixed",
  popperConfig: {
    strategy: "fixed",
    modifiers: [
      { name: "preventOverflow", options: { boundary: document.body } },
      { name: "computeStyles", options: { adaptive: false } },
    ],
  },
};

export default function AvailabilityHeader({
  availabilityType,
  setAvailabilityType,
  columnFilters,
  handleFiltering,
  isLock,
  isHidden,
}) {
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [isOpenType, setIsOpenType] = useState(false);

  const value = columnFilters.find((f) => f.id === AVAILABILITY_KEY)?.value ?? "N";
  const isDefault = value === "N";
  const selectedOption = availabilityOptions.find((o) => o.value === value);

 const toggleFilter = () => {
  if (isHidden || isLock) return;
  setIsOpenFilter((prev) => !prev);
};

const handleSelectFilter = (selectedValue) => {
  setIsOpenFilter(false);

  handleFiltering(
    AVAILABILITY_KEY,
    selectedValue === "N" ? "" : selectedValue
  );
};

const handleSelectType = (selectedValue) => {
  setIsOpenType(false);
  setAvailabilityType(selectedValue);
};
  const tip = isDefault ? getHeaderTooltip("BS") : AV_TIP[value] ?? "Beschikbaarheid";

  const button = (
    <button
      type="button"
      className={`d-flex justify-content-center align-items-center border rounded planscreen__column-header ${
        isDefault ? "planscreen__column-header--disabled" : ""
      }`}
      disabled={isLock}
      data-col-name="Bs"
      data-col-value={value}
    >
      <div>Bs</div>
      {!isDefault && (
        <span className="d-flex align-items-center ms-1">{selectedOption?.icon ?? value}</span>
      )}
    </button>
  );

  return (
    <div className="d-flex gap-3 justify-content-center align-items-center">
      <Dropdown className="planscreen__dropdown" isOpen={isOpenFilter} toggle={toggleFilter}>
        <DropdownToggle tag="span" className="p-0">
          {tip ? (
            <Tippy content={tip} placement="top" arrow appendTo={() => document.body}>
              <span>{button}</span>
            </Tippy>
          ) : (
            button
          )}
        </DropdownToggle>

        <DropdownMenu
          className="dropdown-menu-lg menu-dropdown planscreen__dropdown--bs planscreen__dropdown--calendar"
          {...menuProps}
        >
          <Nav vertical>
            {availabilityOptions.map((option) => (
              <DropdownItem
                key={option.value}
                toggle={false}
                active={option.value === value}
                onClick={() => handleSelectFilter(option.value)}
              >
                {option.label}
              </DropdownItem>
            ))}
          </Nav>
        </DropdownMenu>
      </Dropdown>

      {!isHidden && (
        <Dropdown
          className="planscreen__dropdown"
          isOpen={isOpenType}
          toggle={() => setIsOpenType((prev) => !prev)}
        >
          <DropdownToggle
            color="link"
            className="d-flex justify-content-center align-items-center gap-1 p-0"
          >
            <Tippy
              content={getHeaderTooltip(
                availabilityType === "rooster" ? "BS_MODE_ROOSTER" : "BS_MODE_DAGDELEN"
              )}
              placement="top"
              arrow
              appendTo={() => document.body}
            >
              <span className="d-inline-flex items-center gap-1">
                {availabilityTypeOptions.find((o) => o.value === availabilityType)?.icon ?? ""}
              </span>
            </Tippy>
          </DropdownToggle>

          <DropdownMenu
            className="dropdown-menu-lg menu-dropdown planscreen__dropdown--bs planscreen__dropdown--calendar"
            {...menuProps}
          >
            <Nav vertical>
              {availabilityTypeOptions.map((option) => (
                <DropdownItem key={option.value} toggle={false} onClick={() => handleSelectType(option.value)}>
                  <span className="d-inline-flex items-center gap-2">{option.label}</span>
                </DropdownItem>
              ))}
            </Nav>
          </DropdownMenu>
        </Dropdown>
      )}
    </div>
  );
}